import { modalService } from "@whatslly/ui-components/modals";
import type { IUserStore } from "@whatslly/ui-components/services/UserStore";
import { EtokenExpired } from "./EtokenExpiredModal";

export * from "./EtokenExpiredModal";

export const openEtokenExpiredModal = async (userStore: IUserStore, logoutText?: string) => {
  if (!userStore.user?.showEtokenExpiredModal) {
    return false;
  }
  if (modalService.modalInstances.length !== 0) {
    return;
  }
  const result = await modalService.openModal(EtokenExpired, {
    etokenExpired: {
      base: userStore.user?.base,
      logoutText,
    },
    loginProvider: userStore.loginProvider,
  }).promise;

  return result;
};
